import { Box, Typography } from '@mui/material';
import type { ColumnDef } from '../../../shared/components/SortableTable';
import type { LiveEvent } from '../../../types/frontend';
import TimeCell from './TimeCell';
import CategoryIcon from './CategoryIcon';
import { friendlyType, extractSeverity, buildSummary } from '../utils/eventDisplay';

export const timeColumn: ColumnDef<LiveEvent> = {
  key: 'time',
  label: 'Time',
  sortValue: (e) => new Date(e.timestamp).getTime(),
  render: (e) => <TimeCell iso={e.timestamp} />,
};

export const typeColumn: ColumnDef<LiveEvent> = {
  key: 'type',
  label: 'Type',
  sortValue: (e) => friendlyType(e),
  render: (e) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
      <CategoryIcon source={e.source} size={16} />
      <Typography variant="body2" noWrap>{friendlyType(e)}</Typography>
    </Box>
  ),
};

export const severityColumn: ColumnDef<LiveEvent> = {
  key: 'severity',
  label: 'Severity',
  sortValue: (e) => extractSeverity(e)?.level ?? 'zzz',
  render: (e) => <Typography variant="body2">{extractSeverity(e)?.label ?? '—'}</Typography>,
};

export const summaryColumn: ColumnDef<LiveEvent> = {
  key: 'summary',
  label: 'Summary',
  sortValue: (e) => buildSummary(e),
  render: (e) => (
    <Typography variant="body2" noWrap title={buildSummary(e)}>
      {buildSummary(e)}
    </Typography>
  ),
};

export const sourceColumn: ColumnDef<LiveEvent> = {
  key: 'source',
  label: 'Source',
  sortValue: (e) => e.source,
  render: (e) => (
    <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
      {e.source}
    </Typography>
  ),
};

export const EVENT_COLUMNS: ColumnDef<LiveEvent>[] = [
  timeColumn, typeColumn, severityColumn, summaryColumn, sourceColumn,
];
